import React from "react";

// Styles
import SupplementaryInformationViewContainer from "./SupplementaryInformationView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface SupplementaryInformationViewProps {}

const SupplementaryInformationView =
    ({}: SupplementaryInformationViewProps) => {
        return (
            <SupplementaryInformationViewContainer>
                <div className="iframeContainer">
                    <PowerBIDashboard
                        reportId="9e83ca82-7424-4eab-95e1-a3e79e207dbe"
                        workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                    ></PowerBIDashboard>
                </div>
            </SupplementaryInformationViewContainer>
        );
    };
export default SupplementaryInformationView;
